export default {
  // 新增粮油类型
  insertYxOilType: '/ygsjzs/yxOilType/insertYxOilType',
  // 修改粮油类型
  updateYxOilType: '/ygsjzs/yxOilType/updateYxOilType',
  // 删除粮油类型
  deleteYxOilType: '/ygsjzs/yxOilType/deleteYxOilType',
  // 查询粮油类型详情
  selectYxOilTypeByTypeId: '/ygsjzs/yxOilType/selectYxOilTypeByTypeId',
  // 查询粮油类型列表
  selectYxOilTypeByList: '/ygsjzs/yxOilType/selectYxOilTypeByList'

}
